import { useState, useEffect } from 'react';

interface IPropsApplied {
  dragging: boolean;
  valid: boolean;
  props: {
    onDragOver;
    onDragEnter;
    onDragLeave;
    onDrop;
  };
}

interface IArguments {
  accept?: string[];
  onChange: (fileList: FileList) => void;
}
// eslint-disable-next-line
export const useDropZone: (args: IArguments) => IPropsApplied = ({ onChange, accept = [] }) => {
  const [dragging, setDragging] = useState(false);
  const [valid, setValid] = useState(true);

  const checkTypes = fileList => {
    if (
      accept.length > 0 &&
      [...fileList].filter(({ type }) => accept.indexOf(type) === -1).length > 0
    ) {
      setValid(false);
    }
  };

  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = e => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      checkTypes(e.dataTransfer.items);
      setDragging(true);
    }
  };

  const handleDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();

    setDragging(false);
  };

  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();

    setDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onChange(e.dataTransfer.files);
    }
  };

  useEffect(() => {
    if (!dragging) {
      setValid(true);
    }
  }, [dragging]);

  return {
    dragging,
    valid,
    props: {
      onDragOver: handleDrag,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
    },
  };
};
